export const CREATE_CONTENT_REQUEST = "content/CREATE_CONTENT_REQUEST";
export const CREATE_CONTENT_SUCCESS = "content/CREATE_CONTENT_SUCCESS";
export const CREATE_CONTENT_FAILURE = "content/CREATE_CONTENT_FAILURE";

export const READ_CONTENT_REQUEST = "content/READ_CONTENT_REQUEST";
export const READ_CONTENT_SUCCESS = "content/READ_CONTENT_SUCCESS";
export const READ_CONTENT_FAILURE = "content/READ_CONTENT_FAILURE";

export const UPDATE_CONTENT_REQUEST = "content/UPDATE_CONTENT_REQUEST";
export const UPDATE_CONTENT_SUCCESS = "content/UPDATE_CONTENT_SUCCESS";
export const UPDATE_CONTENT_FAILURE = "content/UPDATE_CONTENT_FAILURE";

export const DELETE_CONTENT_REQUEST = "content/DELETE_CONTENT_REQUEST";
export const DELETE_CONTENT_SUCCESS = "content/DELETE_CONTENT_SUCCESS";
export const DELETE_CONTENT_FAILURE = "content/DELETE_CONTENT_FAILURE";

export const READ_CONTENTS_REQUEST = "content/READ_CONTENTS_REQUEST";
export const READ_CONTENTS_SUCCESS = "content/READ_CONTENTS_SUCCESS";
export const READ_CONTENTS_FAILURE = "content/READ_CONTENTS_FAILURE";

export const READ_TAGS_REQUEST = "content/READ_TAGS_REQUEST";
export const READ_TAGS_SUCCESS = "content/READ_TAGS_SUCCESS";
export const READ_TAGS_FAILURE = "content/READ_TAGS_FAILURE";

export const RESET_FILTER = "content/RESET_FILTER";

export const FILTER_CONTENTS_REQUEST = "content/FILTER_CONTENTS_REQUEST";
export const FILTER_CONTENTS_SUCCESS = "content/FILTER_CONTENTS_SUCCESS";
export const FILTER_CONTENTS_FAILURE = "content/FILTER_CONTENTS_FAILURE";

export const UPLOAD_IMAGE_REQUEST = "content/UPLOAD_IMAGE_REQUEST";
export const UPLOAD_IMAGE_SUCCESS = "content/UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_FAILURE = "content/UPLOAD_IMAGE_FAILURE";



// WEBPACK FOOTER //
// ./src/modules/content/content.actionTypes.js